import { Link } from "react-router-dom";
import { AlertTriangle, Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center p-8" data-testid="not-found-page">
      <div className="max-w-xl text-center">
        <div className="mx-auto w-16 h-16 border-2 border-[#F4D03F] flex items-center justify-center mb-6">
          <AlertTriangle className="w-8 h-8 text-[#F4D03F]" />
        </div>
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#F4D03F] mb-3">
          / OFF-MAP TERRITORY
        </div>
        <div className="font-heading font-black text-5xl sm:text-6xl uppercase tracking-tight mb-4">
          Position not held
        </div>
        <p className="text-gray-400 mb-8">
          The scouts couldn't find this URL. Fall back to a known objective.
        </p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Link to="/" className="border-2 border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-black uppercase tracking-widest text-xs font-bold px-5 py-3 inline-flex items-center gap-2">
            <Compass className="w-3.5 h-3.5" /> Head to base
          </Link>
          <Link to="/standings" className="border border-[#232330] text-gray-300 hover:border-white hover:text-white uppercase tracking-widest text-xs px-5 py-3">
            Standings
          </Link>
          <Link to="/schedule" className="border border-[#232330] text-gray-300 hover:border-white hover:text-white uppercase tracking-widest text-xs px-5 py-3">
            Schedule
          </Link>
        </div>
      </div>
    </div>
  );
}
